/** @jsx jsx */
import type { ReactNode } from 'react';
import { styled } from '@compiled/react';
import { jsx, cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Link, type LinkProps } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';

const styles = cssMap({
	link: {
		display: 'block',
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'none',
		},
	},
	linkFocused: {
		'&:focus': {
			outline: `2px solid ${token('color.border.focused')}`,
			outlineOffset: token('space.025'),
			backgroundColor: 'transparent',
		},
	},
});

type NavigationLinkProps = LinkProps & { isLinkFocused?: boolean; children: ReactNode };

export const NavigationLinkNew = ({ isLinkFocused, children, ...props }: NavigationLinkProps) => {
	return (
		<Link {...props} css={[styles.link, isLinkFocused && styles.linkFocused]}>
			{children}
		</Link>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NavigationLinkOld = styled(Link)({
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'none',
	},
});

export const NavigationLink = componentWithCondition(
	() => fg('dee-8683-compal-a11y-button-keyboard-accessibility'),
	NavigationLinkNew,
	NavigationLinkOld,
);
